<template>
  <v-card class="banner__logo" :class="!isMobileBreakpoint ? 'mx-6' : ''" flat>
    <div class="d-flex container__title">
      <img
        src="@/assets/pandaBrandingBanner/big-play.svg"
        class="hide-mobile mr-6"
      />
      <div class="content-wrapper d-flex">
        <div class="d-flex flex-column mr-md-9">
          <span class="bannerTitle">
            {{ $i18next.t('message.banners.pandaBrandingBanner.title') }}
          </span>
          <span class="subtitle white--text font-weight-regular">
            {{ $i18next.t('message.banners.pandaBrandingBanner.subtitle') }}
          </span>
        </div>
        <div class="d-flex align-end">
          <div class="mb-md-1 mt-md-0 mt-2">
            <BaseBtn
              type="tertiary"
              @click="redirectPlayerPageLogo"
              class="bg-dark--ignore redirect-btn"
            >
              {{ $i18next.t('message.banners.pandaBrandingBanner.action') }}
            </BaseBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="close-banner">
      <v-icon color="white" size="20px" @click="handleClose">mdi-close</v-icon>
    </div>
  </v-card>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import Storage from '@/utils/Storage'
import { mapState } from 'vuex'

export default {
  name: 'PandaBrandingBanner',
  components: { BaseBtn },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    ...mapState('user', {
      isTabletBreakpoint: 'isTabletBreakpoint',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
  },
  methods: {
    redirectPlayerPageLogo() {
      this.$router.push({ name: 'Player', query: { tab: 3 } })
    },
    handleClose() {
      Storage.setItem('hasClosedPandaBrandingBanner', true)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.close-banner {
  position: absolute;
  right: 8px;
  top: 4px;
}

.redirect-btn {
  background-color: #edeef1 !important;
  border-color: #edeef1 !important;
  color: #3f404c !important;
}

.container__title {
  justify-content: center;
  align-items: center;
  width: 100%;
}

.content-wrapper {
  display: flex;
  align-items: center;
  gap: 13vw;
}
.banner__logo {
  min-height: 94px;
  height: 94px;
  border-radius: 4px;
  background: linear-gradient(263deg, #425af0 22.15%, #182996 90.09%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
}

.mirror {
  -webkit-transform: scaleX(-1) scaleY(-1);
  transform: scaleX(-1) scaleY(-1);
}

.bannerTitle {
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.subtitle {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.page-view {
  &__container.has-pre-content {
    grid-template-areas: 'header-mobile' 'pre-content' 'content' 'header' !important;
    grid-template-rows: auto auto 1fr auto !important;

    @media (min-width: 680px) {
      grid-template-areas: 'header' 'pre-content' 'content' !important;
      grid-template-rows: auto auto 1fr !important;
    }
  }
}

@media screen and (max-width: 1100px) {
  .hide-mobile {
    display: none !important;
  }

  .banner__logo {
    justify-content: center;
  }
}

@media screen and (max-width: 982px) {
  .container__title {
    flex-direction: column;
  }

  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: 75px auto calc(100vh - 249px) !important;
  }

  .banner__logo {
    height: unset;
  }
}

@media screen and (max-width: 679px) {
  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: auto auto 1fr auto !important;
  }
}

@media screen and (max-width: 572px) {
  .banner__logo {
    padding: 20px 20px;
  }
}
</style>
